import '../style.scss'
import { useEffect, useState } from "react"
import { FiChevronDown } from "react-icons/fi"
import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, SidePopupContainer } from "src/style"
import { VscSmiley } from 'react-icons/vsc'
import { IoDocumentTextOutline, IoImageOutline } from 'react-icons/io5'
import { ImAttachment } from 'react-icons/im'


export const CallSheduleTime: React.FC<any> = ({showSummary, close}) => {
    
    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => { document.body.style.overflow = 'auto' }
    }, [])
    
    return (
        <>
            <FixedContainer 
                className="service-request-container" 
                zIndex="9" radius="0.8" bgColor="#ffffff"
                topPadding="1.5" width='34.8' height='47.6'
            >
                <Form style={{height: '100%'}}>
                    <FlexColumn 
                        height="100" hUnit="%" padding="2.5" 
                        topPadding="1" justifyContent='space-between'
                    >
                        <CustomContainer>
                            <AppLabel fontWeight='600' color='#000000'>Pick date</AppLabel>
                            <CustomContainer>
                                <FormGroup bottomMargin="1.5">
                                    <input 
                                        placeholder='Enter call date'
                                        name='date' type="date"
                                    />
                                </FormGroup>
                            </CustomContainer>
                            <CustomContainer topMargin='1.5'>
                                <AppLabel fontWeight='600' color='#000000'>Pick time</AppLabel>
                                <FlexRow gap="1.5" justifyContent="space-between" bottomMargin="1.5">
                                    <FormGroup bottomMargin="0">
                                        <input 
                                            placeholder='Start time'
                                            name='startTime' type="time"
                                        />
                                    </FormGroup>
                                    <AppText>-</AppText>
                                    <FormGroup bottomMargin="0">
                                        <input 
                                            placeholder='End time'
                                            name='endTime' type="time"
                                        />
                                    </FormGroup>
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>
                        <FlexRow justifyContent='flex-end'>
                            <Button
                                width='7.1' borderColor='#E4ECF7' height='3.6'
                                hoverBgColor='#E4ECF7' hoverColor='#505780'
                                bgColor="#ffffff" color="#505780" rightMargin='1'
                                titleSize='1.2' radius='0.6'
                            >
                                Clear
                            </Button>
                            <Button
                                width='7.4' borderColor='#4C6FFF' height='3.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                titleSize='1.2' radius='0.6'
                                onClick={showSummary}
                            >
                                Apply
                            </Button>
                        </FlexRow>
                    </FlexColumn>
                </Form>
            </FixedContainer>
        </>
    )
}